import React from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Header from './components/Header'

function App() {
  const location = useLocation()
  const navigate = useNavigate()

  // Determine if the current path is '/'
  const shouldDisplayHeader = location.pathname === '/'
  const shouldDisplayCloseButton = location.pathname !== '/'

  // Handler for going back to the previous page
  const handleGoBack = () => {
    navigate(-1) // Navigate to the previous URL
  }

  return (
    <>
      {shouldDisplayHeader && <Header />}
      {shouldDisplayCloseButton && (
        <IconButton
          onClick={handleGoBack}
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            zIndex: 1000,
          }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
      )}

      <div className="App">
        {/* Render child routes */}
        <Outlet />
      </div>
    </>
  )
}

export default App
